import { Card, Grid, Modal } from "@mui/material";
import MDButton from "components/MDButton";

// import { colorScheme } from 'default';
import Map from "components/Map/map";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function DisplayMapModal({ ...props }) {
  const center = {
    lat: parseFloat(props.lat),
    lng: parseFloat(props.long),
  };
  const handleCoordinateChange = (newCoordinates) => {
    props.onCoordinateChange(newCoordinates);
  };
  return (
    <Modal
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <Map cordinate={center} onCoordinateChange={handleCoordinateChange} />
        <Grid
          container
          id="modal-modal-description"
          sx={{ mt: 2, justifyContent: "center" }}
        >
          <MDButton
            color="warning"
            onClick={props.handleCancel}
            sx={{ width: "64px", textTransform: "capitalize" }}
          >
            Back
          </MDButton>
        </Grid>
      </Card>
    </Modal>
  );
}

export default DisplayMapModal;
